import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Modal } from '@material-ui/core';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import './Warning-Popup.scss';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const WarningPopup = (props) => {
  const classes = useStyles();
  const {
    warningPopup,
    onWarningClose,
    warn,
    close,
    isClose = true,
    onWarningOk,
    isTitleNameShow = true,
  } = props;
  const [modalStyle] = useState(getModalStyle);

  const handleOnClose = () => {
    onWarningClose();
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <div className='warning-popup'>
        <div className='warning-popup-title'>
          <WarningAmberRoundedIcon />
          Unable to {warningPopup?.type ? warningPopup?.type : 'delete'} <br />{' '}
          {!isTitleNameShow ? '' : warningPopup?.name}
        </div>
        <p className='warning-popup-description'>
          {warningPopup?.description
            ? warningPopup?.description
            : 'The selected attribute cannot be deleted as it is associated with Room Configurations'}
        </p>
        <div className='d-flex justify-content-center'>
          <Button
            variant='contained'
            size='large'
            color='primary'
            onClick={(e) => (isClose ? handleOnClose() : onWarningOk())}
          >
            {close ?? 'Back'}
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <Modal open={warningPopup?.status || warn} onClose={handleOnClose}>
      {body}
    </Modal>
  );
};

export default WarningPopup;
